export const MESSAGING_ALLOWLIST_LIMITS = {
  MAX_PATTERNS_PER_CHANNEL: 50,
  MAX_PATTERN_LENGTH: 255,
} as const;
